import client from '../client';

interface Request {
  prefix: string;
}

export interface LineOASettingResponse {
  id?: number;
  vender_id?: number;
  name?: string;
  url?: string;
  is_visible?: boolean;
  sort?: number;
}

export default function API(request: Request): Promise<LineOASettingResponse[]> {
  return client
    .get(`genaral/get_line_oa_settings_by_prefix`, { params: request })
    .then(response => response.data)
    .then(json => {
      return json;
    });
}
